import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Form,
  Row,
  Col,
  Button,
  Input,
  Table,
  Tabs,
  message,
  Modal,
  Spin,
  Dropdown,
  Menu,
  Card,
  Divider,
  Upload,
} from "antd";
import { withAppContext } from "../../store/contextStore";
import "./index.scss";
import AppConfigs from "../../Config/AppConfig";
import { Auth, Storage } from "aws-amplify";
import { getDetails, list } from "../../api/Apis";
import UserLogo from "../../Images/user.png";
import LocationAutocomplete from "../../Components/Autocomplete";
import {
  EditFilled,
  DeleteFilled,
  CloseOutlined,
  EditOutlined,
  CameraOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Docsample from "../../Images/pdf.jpg";
import { add, update, deleteRecord } from "../../api/Apis";
import PriceQuoteTool from "./PriceQuoteTool";
import { formatPhoneNumber, formatPhoneNumber1 } from "../commonFunctions";
import ResizableAntdTable from "resizable-antd-table";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import ErrorPage from "../ErrorPage";
import Text from "antd/lib/typography/Text";
import DownloadCsv from "../../Components/DownloadCsv";
// import mapImage from '../../Images/slider.png';

const { TabPane } = Tabs;
const Search = Input.Search;
class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      dataLoadingStatus: true,
      yardLocations: [],
      totalYardLocations: [],
      usersData: [],
      totalUsersData: [],
      visible: false,
      imageModal: false,
      subVisible: false,
      displayProducts: [],
      categories: [],
      subCategories: [],
      displaySub: [],
      masterData: { category: [], subCategory: [] },
      selectedCategory: "",
      selectedTag: "",
      questionTitle: "",
      title: "",
      mapPath: "",
      categoriesDataLoading: false,
      subCategoriesDataLoading: false,
      tagsDataLoading: false,
      userModalVisible: false,
      userData: {},
      formSubmitStatus: false,
      action: "",
      pricesheetDataLoading: false,
      templateData: "",
      pricesheetVisible: false,
      selectedTemplateAddress: "",
      pricesheetDataUpdate: false,
      companyLogo: "",
    };
  }

  componentDidMount() {
    let yardLocations = [];
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    // let imagePath = "";
    if (orgDetails["yardLocations"]) {
      // orgDetails["yardLocations"].map(async(loc, index) => {
      //     // loc['id'] = loc["id"];
      //     imagePath = await Storage.get(loc['mapImage'][0]);
      //     loc['map'] = imagePath;
      //     return loc;
      //     // ['map'] = <span onClick={() => this.showImageModal(imagePath)} style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}>Show location map</span> //await Storage.get(loc['mapImage'][0]);
      // })
      yardLocations = orgDetails["yardLocations"];
    }
    this.setState({
      yardLocations: yardLocations,
      totalYardLocations: yardLocations,
    });
    console.log('yardLocations: ', yardLocations)
    this.getUsers();
    this.getCategoriesAndSubCategories("category", "categoriesDataLoading");
    this.getCategoriesAndSubCategories(
      "subCategory",
      "subCategoriesDataLoading"
    );
    this.getCategoriesAndSubCategories(
      "carrierTag",
      "subCategoriesDataLoading"
    );
    this.getTemplateDetails();
    console.log('state: ', this.state)
  }

  getUsers = () => {
    let query = {
      userProfile: ["A", "M"],
    };
    list(AppConfigs["entityNames"]["adminUsers"], query).then(
      async (result) => {
        if (result.success) {
          let usersData = [];
          let userCount = 0;
          await result["data"].map(async (user) => {
            let userImg = user["profilePic"]
              ? await Storage.get(user["profilePic"])
              : UserLogo;
            user["avatar"] = (
              <img
                src={userImg}
                style={{ width: "75px", height: "75px", borderRadius: "10px" }}
                alt={user["firstName"]}
              />
            );
            usersData.push(user);
            userCount += 1;
            if (userCount === usersData.length) {
              this.setState({
                dataLoadingStatus: false,
                totalUsersData: usersData,
                usersData: usersData,
              });
            }
            console.log("userdata??", usersData)
            return user;
          });
        } else {
          this.setState({
            dataLoadingStatus: false,
          });
          console.log(result.errors);
        }
      }
    );
  };

  beforeUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isLt2M;
  }

  handleUploadPic = async (fileData, imageType) => {
    if (fileData.event) {
      this.setState({
        pricesheetDataLoading: true,
      });
      let file = fileData["file"]["originFileObj"];
      let fileName =
        this.state.templateData?.id + imageType + "_" + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then(async (result) => {
        this.setState({
          companyLogo: result.key,
          pricesheetDataLoading: false,
        });
        // let data = {};
        // data["entityData"] = {};
        // data["entityData"]["companyLogo"] = result.key;
        // update(
        //   AppConfigs["entityNames"]["organizations"],
        //   "74e23590-5bcc-11eb-8c1a-eb07997ac9a4",
        //   data
        // ).then(async (result) => {
        //   if (result.success) {
        //     message.success("Company Logo Update Successfully");
        //     this.setState({
        //       pricesheetDataLoading: false,
        //     });
        //     localStorage.setItem(
        //       "orgDetails",
        //       JSON.stringify(result.data.data)
        //     );
        //   } else {
        //     message.error(result.errors);
        //     this.setState({
        //       pricesheetDataLoading: false,
        //     });
        //   }
        // });
      });
    }
  };

  getTemplateDetails = () => {
    this.setState({ pricesheetDataLoading: true });
    getDetails(
      AppConfigs["entityNames"]["organizations"],
      "74e23590-5bcc-11eb-8c1a-eb07997ac9a4"
    ).then((result) => {
      if (result.success) {
        this.setState({
          templateData: result.data,
          companyLogo: result.data.companyLogo,
          pricesheetDataLoading: false,
        });
        localStorage.setItem("orgDetails", JSON.stringify(result.data));
      } else {
        this.setState({
          pricesheetDataLoading: false,
          errors: result.errors,
        });
      }
    });
  };

  getCategoriesAndSubCategories = (dataType, loadingVariable) => {
    let query = {
      dataType: dataType,
      recordStatus: true,
    };
    this.setState({
      [loadingVariable]: true,
    });
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        let masterData = this.state.masterData;
        masterData[dataType] = result.data;
        this.setState({
          masterData: masterData,
          [loadingVariable]: false,
        });
        if (dataType === "category") {
          this.setState({
            selectedCategory: result.data?.[0]?.["id"],
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
      console.log("result cat", result);
    });
  };

  // addUser = () => {
  //     localStorage.setItem("tab","user")
  //     this.props.history.push('/app/addlocation');
  // }

  addLocation = () => {
    localStorage.setItem("tab", "location");
    this.props.history.push("/app/settings/addlocation?actionType=new");
  };
  addUser = () => {
    localStorage.setItem("tab", "user");
    this.props.history.push("/app/settings/adduser");
  };

  callback(key) {
    console.log(key);
  }
  showImageModal = (imagePath) => {
    console.log(imagePath);
    this.setState({
      imageModal: true,
      mapPath: imagePath,
    });
  };
  imageHandleOk = () => {
    this.setState({
      imageModal: false,
    });
  };
  imageHandleCancel = () => {
    this.setState({
      imageModal: false,
    });
  };
  showCatAndSubCatModal = (id, value, type, action) => {
    let title = action === "new" ? "Add new " : "Update ";
    let buttonTitle = action === "new" ? "Add" : "Update";
    let questionTitle = "";
    if (type === "category") {
      title += "category";
      questionTitle = "Category name";
    } else if (type === "carrierTag") {
      title += "tag";
      questionTitle = "Tag";
    } else {
      title += "sub category";
      questionTitle = "Sub-Category name";
    }
    this.props.form.setFieldsValue({
      fieldValue: value,
      fieldType: type,
      recordId: id,
    });
    this.setState({
      visible: true,
      title: title,
      buttonTitle: buttonTitle,
      questionTitle: questionTitle,
      catAndSubCatAddingLoadingStatus: false,
      action: action,
    });
    console.log('caty state: ', this.state);
  };

  handleOk = (e) => {
    this.props.form.validateFieldsAndScroll(
      ["fieldType", "fieldValue", "recordId"],
      (err, values) => {
        if (!err) {
          console.log(values, this.state.action);
          this.setState({
            catAndSubCatAddingLoadingStatus: true,
          });
          let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
          let data = {
            entityData: {
              dataType: values["fieldType"],
              name: values["fieldValue"],
              orgId: orgDetails["id"],
              recordStatus: true,
            },
          };
          if (values["fieldType"] === "subCategory") {
            data["entityData"]["categoryId"] = this.state.selectedCategory;
          }
          if (values["recordId"]) {
            data["entityData"]["id"] = values["recordId"];
          }
          add(AppConfigs["entityNames"]["masterData"], data).then((result) => {
            if (result.success) {
              message.success(values["fieldType"] + " created successfully");
              let loadingField =
                values["fieldType"] === "category"
                  ? "categoriesDataLoading"
                  : "subCategoriesDataLoading";
              this.setState({
                visible: false,
                loading: false,
                catAndSubCatAddingLoadingStatus: false,
              });
              this.getCategoriesAndSubCategories(
                values["fieldType"],
                loadingField
              );
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });
        }
      }
    );
  };

  handleEdit = (e) => {
    this.props.form.validateFieldsAndScroll(
      ["firstName", "lastName", "email", "phone"],
      (err, values) => {
        if (!err && !values.recordId) {
          this.setState({
            formSubmitStatus: true,
          });
          let data = {};
          data["entityData"] = values;
          update(
            AppConfigs["entityNames"]["users"],
            this.state.userData.id,
            data
          ).then((result) => {
            if (result.success) {
              message.success(`User details updated successfully.`);
            } else {
              message.error(result.errors);
            }
            this.setState({
              formSubmitStatus: false,
              userModalVisible: false,
            });
            window.location.reload();
          });
        }
      }
    );
  };

  deleteCategory(id, fieldType) {
    let data = {
      entityData: {
        recordStatus: false,
      },
    };
    let loadingField =
      fieldType === "category"
        ? "categoriesDataLoading"
        : "subCategoriesDataLoading";
    this.setState({
      [loadingField]: true,
    });
    update(AppConfigs["entityNames"]["masterData"], id, data).then((result) => {
      if (result.success) {
        message.success(fieldType + " deleted successfully");
        this.setState({
          [loadingField]: false,
        });
        this.getCategoriesAndSubCategories(fieldType, loadingField);
      } else {
        this.setState({
          loading: false,
        });
        console.log(result.errors);
      }
    });
  }

  deleteUser = (id) => {
    this.setState({ dataLoadingStatus: true });
    deleteRecord(AppConfigs["entityNames"]["users"], id).then((result) => {
      if (result.success) {
        message.success("User deleted successfully");
        this.getUsers();
      } else {
        console.log(result.errors);
      }
    });
  };

  async resendConfirmationCode(username) {
    try {
      this.setState({ dataLoadingStatus: true });
      await Auth.resendSignUp(username);
      this.setState({ dataLoadingStatus: false });
      message.success("code resent successfully");
    } catch (err) {
      console.log("error resending code: ", err);
    }
  }
  searchData = (event, searchBy) => {
    let searcingValue = event.target.value;
    let usersData = this.state.totalUsersData;
    let yardLocations = this.state.totalYardLocations;
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchBy === "users") {
        // usersData = this.state.totalUsersData.filter((user) => user.firstName.toLowerCase().indexOf(searcingValue) > -1 || user.lastName.toLowerCase().indexOf(searcingValue) > -1 || user.email.indexOf(searcingValue) > -1)
        usersData = this.state.totalUsersData.filter(
          (user) =>
            user.firstName.toLowerCase().indexOf(searcingValue) > -1 ||
            user.lastName.toLowerCase().indexOf(searcingValue) > -1 ||
            user.email.indexOf(searcingValue) > -1 ||
            user.phone.toLowerCase().indexOf(searcingValue) > -1
        );
      } else {
        // yardLocations = this.state.totalYardLocations.filter((location) => location.locationName.toLowerCase().indexOf(searcingValue) > -1 || location.address.toLowerCase().indexOf(searcingValue) > -1 || location.firstName.toLowerCase().indexOf(searcingValue) > -1 || location.lastName.toLowerCase().indexOf(searcingValue) > -1 || (location.loadTypes && location.loadTypes.join(", ").toLowerCase().indexOf(searcingValue) > -1) || (location.materialsLoaded && location.materialsLoaded.join(", ").toLowerCase().indexOf(searcingValue) > -1))
        yardLocations = this.state.totalYardLocations.filter(
          (location) =>
            location.locationName.toLowerCase().indexOf(searcingValue) > -1 ||
            location.address.toLowerCase().indexOf(searcingValue) > -1 ||
            location.firstName.toLowerCase().indexOf(searcingValue) > -1 ||
            location.lastName.toLowerCase().indexOf(searcingValue) > -1 ||
            (location.loadTypes &&
              location.loadTypes
                .join(", ")
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            (location.materialsLoaded &&
              location.materialsLoaded
                .join(", ")
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
            location.phone.toLowerCase().indexOf(searcingValue) > -1 ||
            location.loadingTimes.toLowerCase().indexOf(searcingValue) > -1
        );
      }
    }
    this.setState({
      usersData: usersData,
      yardLocations: yardLocations,
    });
  };

  showPriceSheetModal = () => {
    const priceSheetData = this.state.templateData;
    this.setState({
      pricesheetVisible: true,
      selectedTemplateAddress: priceSheetData.address,
    });
    this.props.form.setFieldsValue({
      companyName: priceSheetData.companyName,
      address: priceSheetData.address,
      phone: priceSheetData.phone,
      email: priceSheetData.email,
      website: priceSheetData.website,
      notes: priceSheetData.notes,
    });
  };

  updateTemplateData = async (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["companyName", "address", "phone", "email", "website", "notes"],
      async (err, values) => {
        if (!err) {
          this.setState({
            pricesheetDataUpdate: true,
          });
          let data = {};
          data["entityData"] = {};
          data["entityData"]["companyName"] = values["companyName"];
          data["entityData"]["address"] = this.state.selectedTemplateAddress;
          data["entityData"]["phone"] = values["phone"];
          data["entityData"]["email"] = values["email"];
          data["entityData"]["website"] = values["website"];
          data["entityData"]["notes"] = values["notes"];
          data["entityData"]["companyLogo"] = this.state.companyLogo;
          update(
            AppConfigs["entityNames"]["organizations"],
            "74e23590-5bcc-11eb-8c1a-eb07997ac9a4",
            data
          ).then(async (result) => {
            if (result.success) {
              message.success("Template Data Update Successfully");
              this.setState({
                templateData: result.data.data,
                pricesheetDataUpdate: false,
                pricesheetVisible: false,
              });
              localStorage.setItem(
                "orgDetails",
                JSON.stringify(result.data.data)
              );
            } else {
              message.error(result.errors);
              this.setState({
                pricesheetDataUpdate: false,
                pricesheetVisible: false,
              });
            }
          });
        }
      }
    );
  };

  render() {
    const { getFieldDecorator, resetFields } = this.props.form;
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const rolePermisions = this.props?.context?.state?.permissions;
    const usersColumns = [
      {
        title: <div style={{ color: "gray" }}>Avatar</div>,
        dataIndex: "avatar",
        key: "avatar",
      },
      {
        title: <div style={{ color: "gray" }}>First Name</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName) => (
          <span>
            <div style={{ color: "black" }}>{firstName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Last Name</div>,
        dataIndex: "lastName",
        key: "lastName",
        render: (lastName) => (
          <span>
            <div style={{ color: "black" }}>{lastName}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Phone</div>,
        dataIndex: "phone",
        key: "phone",
        render: (phone) => (
          <span>
            <div style={{ color: "black" }}>
              {phone.length === 10
                ? formatPhoneNumber(phone)
                : formatPhoneNumber1(phone)}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>UserProfile</div>,
        dataIndex: "userProfile",
        key: "userProfile",
        render: (userProfile) => (
          <span>
            <div style={{ color: "black" }}>
              {userProfile === "A" ? "Admin" : "Manager"}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <Dropdown overlay={menu(id, record)} placement="bottomRight">
            <Button>...</Button>
          </Dropdown>
        ),
      },
    ];
    const menu = (id, record) => (
      <Menu>
        {this.state.userDetails["id"] !== id && (
          <Menu.Item className="blue">
            <span
              style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
              onClick={() => {
                if (
                  window.confirm("Are you sure you want to delete this user?")
                )
                  this.deleteUser(id);
              }}
            >
              Delete
            </span>
          </Menu.Item>
        )}
        {this.state.userDetails["id"] !== id && (
          <Menu.Item
            className="blue"
            onClick={() => {
              this.setState({ userModalVisible: true, userData: record });
            }}
          >
            <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}>
              Edit
            </span>
          </Menu.Item>
        )}
        {!record.isActive && (
          <Menu.Item className="blue">
            <span
              style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
              onClick={() => {
                this.resendConfirmationCode(id);
              }}
            >
              Resend Activation Code
            </span>
          </Menu.Item>
        )}
      </Menu>
    );
    const yardColumns = [
      {
        title: <div style={{ color: "gray" }}>Location Name</div>,
        dataIndex: "locationName",
        key: "locationName",
        render: (locationName) => (
          <div style={{ color: "black" }}>{locationName}</div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Address</div>,
        dataIndex: "address",
        key: "address",
        render: (address) => <div style={{ color: "black" }}>{address}</div>,
      },
      {
        title: <div style={{ color: "gray" }}>Loading Times</div>,
        dataIndex: "loadingTimes",
        key: "loadingTimes",
        render: (loadingTimes) => (
          <div style={{ color: "black" }}>{loadingTimes}</div>
        ),
      },

      {
        title: <div style={{ color: "gray" }}>Contact Info</div>,
        dataIndex: "firstName",
        key: "firstName",
        render: (firstName, record) => (
          <span>
            <div style={{ color: "black" }}>
              {firstName && firstName + " " + record["lastName"]}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {formatPhoneNumber(record.phone)}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Load Types</div>,
        dataIndex: "loadTypes",
        key: "loadTypes",
        render: (loadTypes) => (
          <span>
            <div style={{ color: "black" }}>
              {loadTypes && loadTypes.join(", ")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Materials Loaded</div>,
        dataIndex: "materialsLoaded",
        key: "materialsLoaded",
        render: (materialsLoaded) => (
          <span>
            <div style={{ color: "black" }}>
              {materialsLoaded && materialsLoaded.join(", ")}
            </div>
          </span>
        ),
      },
      // {
      //     title: <div style={{ color: 'gray' }}></div>,
      //     dataIndex: 'map',
      //     key: 'map',
      //     render: (map) => (
      //         <span>
      //           <span onClick={() => this.showImageModal(map)} style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}>Show location map</span>
      //         </span>
      //     )
      // },
      {
        title: <div style={{ color: "gray" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (id) => (
          <span>
            <Button
              style={{
                backgroundColor: "#0E4D90",
                borderColor: "#0E4D90",
                color: "#FFF",
              }}
            >
              <Link
                to={"/app/settings/addlocation?id=" + id + "&actionType=edit"}
              >
                Edit
              </Link>
            </Button>
          </span>
        ),
      },
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    // let categories = { "BULK GRAVEL": ["NEW ENGLAND RIVER ROCK", "BAYSIDE SKIMMERS", "WINCHESTER RIVER ROCK", "CAPE COD RIVER ROCK", "BERKSHIRE BLEND", "BOSTON PURPLE", "CRUSHED COLOR BLEND", "LAKESIDE RIVER ROCK", "ICE BLUE", "GLACIER RIVER ROCK", "CATSKILL RIVER ROCK", "WHITE MARBLE STONE", "SLATE", "SAND", "HARVEST BLEND", "WHITE RIVER ROCK", "LIBERTY PINK"], "PALLETIZED STONE": ["CRUSHED STONE", "PREMIUM STONE LINE", "PALLETIZED RIVER ROCK", "VENEER / FLAGSTONE"] }
    return (
      <div className="content-outer">
        <div className="content">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Tabs
                defaultActiveKey={
                  localStorage.getItem("tab") === "location" ? "2" : "1"
                }
                onChange={this.callback}
              >
                {userDetails.userProfile === "A" && (
                  <TabPane
                    tab={
                      <h1>
                        <b>System Users</b>
                      </h1>
                    }
                    key="1"
                  >
                    <Row style={{ margin: "20px" }}>
                      <Col xs={24} sm={24} md={4} lg={4}>
                        <Search
                          className="products-search"
                          size="large"
                          placeholder="Search"
                          onChange={(event) => this.searchData(event, "users")}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={20} lg={20}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={this.state.loading}
                          onClick={() => this.addUser()}
                          className="upload-button"
                          icon="plus"
                        >
                          Add User
                        </Button>
                      </Col>
                      <Col
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        style={{ marginTop: "2%" }}
                      >
                        <ResizableAntdTable
                          bordered={true}
                          columns={usersColumns}
                          dataSource={this.state.usersData}
                          loading={this.state.dataLoadingStatus}
                          rowKey={(record) => record.id}
                        />
                      </Col>

                      <Modal
                        // title={this.state.categoryTitle}
                        visible={this.state.userModalVisible}
                        footer={[
                          <Button
                            key="cancel"
                            className="cancel"
                            onClick={() => {
                              this.setState({
                                userModalVisible: false,
                                formSubmitStatus: false,
                              });
                              resetFields();
                            }}
                          >
                            Cancel
                          </Button>,
                          <Button
                            key="assign"
                            className="assigning"
                            loading={this.state.formSubmitStatus}
                            onClick={this.handleEdit}
                          >
                            {"Update"}
                          </Button>,
                        ]}
                      >
                        <div className="site-card-border-less-wrapper">
                          <Form>
                            <Card
                              title={
                                <h4 className="Companyheadinglabel">
                                  Edit User
                                </h4>
                              }
                              style={{ borderRadius: "10px" }}
                            >
                              <Row gutter={10}>
                                <Col lg={24} md={24} sm={24} sx={24}>
                                  <Form.Item
                                    className="Formitem"
                                    label={
                                      <span
                                        style={{
                                          color: "#7B8190",
                                          fontSize: "14px",
                                        }}
                                      >
                                        First Name
                                      </span>
                                    }
                                  >
                                    {getFieldDecorator("firstName", {
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Please input your First Name!",
                                        },
                                        noWhitespaceRule,
                                      ],
                                      initialValue:
                                        this.state.userData.firstName,
                                    })(<Input />)}
                                  </Form.Item>
                                </Col>
                                <Col lg={24} md={24} sm={24} sx={24}>
                                  <Form.Item
                                    className="Formitem"
                                    label={
                                      <span
                                        style={{
                                          color: "#7B8190",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Last Name
                                      </span>
                                    }
                                  >
                                    {getFieldDecorator("lastName", {
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Please input your Last Name!",
                                        },
                                        noWhitespaceRule,
                                      ],
                                      initialValue:
                                        this.state.userData.lastName,
                                    })(<Input />)}
                                  </Form.Item>
                                </Col>
                                <Col lg={24} md={24} sm={24} sx={24}>
                                  <Form.Item
                                    className="Formitem"
                                    label={
                                      <span
                                        style={{
                                          color: "#7B8190",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Email
                                      </span>
                                    }
                                  >
                                    {getFieldDecorator("email", {
                                      rules: [
                                        {
                                          required: true,
                                          type: "email",
                                          message: "Please input your Email!",
                                        },
                                      ],
                                      initialValue: this.state.userData.email,
                                    })(<Input disabled={true} />)}
                                  </Form.Item>
                                </Col>
                                <Col lg={24} md={24} sm={24} sx={24}>
                                  <Form.Item
                                    className="Formitem"
                                    label={
                                      <span
                                        style={{
                                          color: "#7B8190",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Phone
                                      </span>
                                    }
                                  >
                                    {getFieldDecorator("phone", {
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Please input your Phone Number!",
                                        },
                                        noWhitespaceRule,
                                        notValidPhoneNumberRule,
                                      ],
                                      initialValue: this.state.userData.phone,
                                    })(<Input />)}
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Form>
                        </div>
                      </Modal>
                      <Button>
                        <DownloadCsv
                          data={this.state.usersData}
                          columns={usersColumns}
                          filename="System_Users"
                        />
                      </Button>
                    </Row>
                  </TabPane>
                )}
                <TabPane
                  tab={
                    <h1>
                      <b>Load Locations</b>
                    </h1>
                  }
                  key="2"
                >
                  <Row style={{ margin: "20px" }}>
                    <Col xs={24} sm={24} md={4} lg={4}>
                      <Search
                        className="products-search"
                        size="large"
                        placeholder="Search"
                        onChange={(event) =>
                          this.searchData(event, "locations")
                        }
                      />
                    </Col>
                    <Col xs={24} sm={24} md={20} lg={20}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={this.state.loading}
                        onClick={() => this.addLocation()}
                        className="upload-button"
                        icon="plus"
                      >
                        Add location
                      </Button>
                    </Col>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "2%" }}
                    >
                      <ResizableAntdTable
                        style={{ overflowX: "auto" }}
                        bordered={true}
                        columns={yardColumns}
                        dataSource={this.state.yardLocations}
                        loading={this.state.dataLoadingStatus}
                        rowKey={(record) => record.id}
                      />
                    </Col>
                  </Row>
                  <Button>
                    <DownloadCsv
                    data={this.state.yardLocations}
                    columns={yardColumns}
                    filename="Locations"
                    />
                  </Button>
                </TabPane>
                <TabPane
                  tab={
                    <h1>
                      <b>Categories</b>
                    </h1>
                  }
                  key="3"
                >
                  <Row style={{ margin: "50px" }}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h1>Categories</h1>
                      <Spin spinning={this.state.categoriesDataLoading}>
                        <Row gutter={[24, 24]}>
                          <div>
                            {this.state.masterData["category"]
                              .sort((a, b) => (a["name"] > b["name"] ? 1 : -1))
                              .map((category) => {
                                return (
                                  <div
                                    className={
                                      this.state.selectedCategory ===
                                      category.id
                                        ? "category_active"
                                        : "category"
                                    }
                                    key={"div" + category["id"]}
                                  >
                                    <li
                                      key={category.id}
                                      onClick={() =>
                                        this.setState({
                                          selectedCategory: category.id,
                                        })
                                      }
                                    >
                                      <Row align="middle">
                                        <Col lg={20} md={20} sm={20} xs={20}>
                                          <p style={{ marginLeft: "10px" }}>
                                            {category.name.toUpperCase()}
                                          </p>
                                        </Col>
                                        <Col lg={2} md={2} sm={2} xs={2}>
                                          <EditFilled
                                            title="Edit"
                                            onClick={() =>
                                              this.showCatAndSubCatModal(
                                                category.id,
                                                category.name,
                                                "category",
                                                "edit"
                                              )
                                            }
                                            style={{
                                              fontSize: "1.2em",
                                              color: "lightgray",
                                            }}
                                          />
                                        </Col>
                                        <Col lg={2} md={2} sm={2} xs={2}>
                                          <DeleteFilled
                                            title="Delete"
                                            onClick={() => {
                                              if (
                                                window.confirm(
                                                  "Are you sure you want to delete this category?"
                                                )
                                              )
                                                this.deleteCategory(
                                                  category.id,
                                                  "category"
                                                );
                                            }}
                                            style={{
                                              fontSize: "1.2em",
                                              color: "lightgray",
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    </li>
                                  </div>
                                );
                              })}
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Button
                                onClick={() =>
                                  this.showCatAndSubCatModal(
                                    null,
                                    null,
                                    "category",
                                    "new"
                                  )
                                }
                                style={{
                                  marginTop: "2%",
                                  backgroundColor: "#0E4D90",
                                  borderColor: "#0E4D90",
                                  color: "#FFF",
                                }}
                              >
                                Add Category
                              </Button>
                              <Button>
                                {/* <DownloadCsv
                                  data={this.state.subCategories}
                                  columns={'categoryColumns'}
                                  filename="customers"
                                /> */}
                              </Button>
                            </Col>
                          </div>
                        </Row>
                      </Spin>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h1>Sub-Categories</h1>
                      <Spin spinning={this.state.subCategoriesDataLoading}>
                        <div>
                          <Row>
                            {this.state.masterData["subCategory"]
                              .filter(
                                (cat) =>
                                  cat.categoryId === this.state.selectedCategory
                              )
                              .sort((a, b) => (a["name"] > b["name"] ? 1 : -1))
                              .map((subCategory) => (
                                <div
                                  className="sub-category"
                                  tabIndex="-1"
                                  key={"subCat" + subCategory.id}
                                >
                                  <li key={subCategory.id}>
                                    <Row>
                                      <Col lg={20} md={20} sm={24} xs={24}>
                                        <p style={{ marginLeft: "10px" }}>
                                          {subCategory.name.toUpperCase()}
                                        </p>
                                      </Col>
                                      <Col lg={2} md={2} sm={24} xs={24}>
                                        <EditFilled
                                          title="Edit"
                                          onClick={() =>
                                            this.showCatAndSubCatModal(
                                              subCategory.id,
                                              subCategory.name,
                                              "subCategory",
                                              "edit"
                                            )
                                          }
                                          style={{
                                            fontSize: "1.2em",
                                            color: "lightgray",
                                          }}
                                        />
                                      </Col>
                                      <Col lg={2} md={2} sm={24} xs={24}>
                                        <DeleteFilled
                                          title="Delete"
                                          onClick={() => {
                                            if (
                                              window.confirm(
                                                "Are you sure you want to delete this sub-category?"
                                              )
                                            )
                                              this.deleteCategory(
                                                subCategory.id,
                                                "subCategory"
                                              );
                                          }}
                                          style={{
                                            fontSize: "1.2em",
                                            color: "lightgray",
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </li>
                                </div>
                              ))}
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Button
                                onClick={() =>
                                  this.showCatAndSubCatModal(
                                    null,
                                    null,
                                    "subCategory",
                                    "new"
                                  )
                                }
                                style={{
                                  marginTop: "2%",
                                  backgroundColor: "#0E4D90",
                                  borderColor: "#0E4D90",
                                  color: "#FFF",
                                }}
                              >
                                Add Sub-Category
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </Spin>
                    </Col>
                    <Modal
                      // title={this.state.categoryTitle}
                      visible={this.state.visible}
                      footer={[
                        <Button
                          key="cancel"
                          className="cancel"
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          Cancel
                        </Button>,
                        <Button
                          key="assign"
                          className="assigning"
                          loading={this.state.catAndSubCatAddingLoadingStatus}
                          onClick={this.handleOk}
                        >
                          {this.state.buttonTitle}
                        </Button>,
                      ]}
                    >
                      <CloseOutlined
                        onClick={() => {
                          this.setState({ visible: false });
                        }}
                        style={{
                          float: "right",
                          cursor: "pointer",
                          fontSize: "1.4em",
                        }}
                      />
                      <h2>{this.state.title}</h2>
                      <div style={{ marginTop: "7%" }}>
                        <Form.Item
                          label={
                            <span style={{ color: "#7B8190" }}>
                              {this.state.questionTitle}
                            </span>
                          }
                        >
                          {getFieldDecorator("fieldValue", {
                            rules: [
                              {
                                required: true,
                                whitespace: true,
                                message: "Please input text",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item>
                          {getFieldDecorator(
                            "recordId",
                            {}
                          )(<Input type="hidden" />)}
                        </Form.Item>
                        <Form.Item>
                          {getFieldDecorator("fieldType", {
                            rules: [
                              {
                                required: true,
                              },
                            ],
                          })(<Input type="hidden" />)}
                        </Form.Item>
                      </div>
                    </Modal>
                  </Row>
                </TabPane>
                <TabPane
                  tab={
                    <h1>
                      <b>Price Sheet Template</b>
                    </h1>
                  }
                  key="4"
                >
                  <Row style={{ margin: "50px" }}>
                    <Spin spinning={this.state.pricesheetDataLoading}>
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <Card
                          title="Price Sheet Template Data"
                          extra={
                            rolePermisions &&
                            rolePermisions[0]?.permissions?.includes(
                              "editCustomer"
                            ) && (
                              <EditOutlined
                                key="edit"
                                onClick={this.showPriceSheetModal}
                                style={{ fontSize: "1.4em" }}
                              />
                            )
                          }
                          style={{ borderRadius: "10px" }}
                        >
                          <Row>
                            <Col xl={8} lg={24} md={24} sm={24} xs={24}>
                              <Text>Company Name</Text>
                            </Col>
                            <Col xl={16} lg={24} md={24} sm={24} xs={24}>
                              <Text>
                                {this.state.templateData?.companyName}
                              </Text>
                            </Col>
                            <Divider />
                            <Col
                              xl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Address</Text>
                            </Col>
                            <Col
                              xl={16}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>{this.state.templateData?.address}</Text>
                            </Col>
                            <Divider />
                            <Col
                              xl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Phone Number</Text>
                            </Col>
                            <Col
                              xl={16}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>
                                {formatPhoneNumber(
                                  this.state.templateData?.phone
                                )}
                              </Text>
                            </Col>
                            <Divider />
                            <Col
                              xxl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Email</Text>
                            </Col>
                            <Col
                              xxl={16}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              {this.state.templateData?.email}
                            </Col>
                            <Divider />
                            <Col
                              xl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Website</Text>
                            </Col>
                            <Col
                              xl={16}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>{this.state.templateData?.website}</Text>
                            </Col>
                            <Divider />
                            <Col
                              xl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Notes</Text>
                            </Col>
                            <Col
                              xl={16}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>{this.state.templateData?.notes}</Text>
                            </Col>
                            <Divider />
                            <Col
                              xl={8}
                              lg={24}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              <Text>Company Logo</Text>
                            </Col>
                            <Col
                              xl={8}
                              lg={8}
                              md={24}
                              sm={24}
                              xs={24}
                              style={{ marginTop: "3%" }}
                            >
                              {this.state?.companyLogo ? (
                                <img
                                  src={
                                    this.state?.companyLogo &&
                                    this.state?.companyLogo.includes(".pdf")
                                      ? Docsample
                                      : `https://${
                                          process.env.REACT_APP_S3_BUCKET
                                        }.s3.amazonaws.com/public/${encodeURIComponent(
                                          this.state?.companyLogo
                                        )}`
                                  }
                                  alt="avatar"
                                  style={{ width: "150px", height: "150px" }}
                                />
                              ) : (
                                <CameraOutlined
                                  className="camera-icon-carrier"
                                  style={{
                                    width: "150px",
                                    height: "150px",
                                    paddingTop: "70px",
                                  }}
                                />
                              )}
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Spin>
                  </Row>
                </TabPane>
                <Form>
                  <Modal
                    visible={this.state.pricesheetVisible}
                    // onOk={this.profileHandleOk}
                    // onCancel={this.profileHandleCancel}
                    closable={true}
                    footer={[
                      <Button
                        key="submit"
                        className="cancel"
                        onClick={() => {
                          this.setState({
                            pricesheetVisible: false,
                          });
                        }}
                      >
                        Cancel
                      </Button>,
                      <Button
                        type="primary"
                        key="editSubmit"
                        htmlType="submit"
                        loading={this.state.pricesheetDataUpdate}
                        onClick={this.updateTemplateData}
                      >
                        Update
                      </Button>,
                    ]}
                  >
                    <CloseOutlined
                      onClick={() => {
                        this.setState({
                          pricesheetVisible: false,
                        });
                      }}
                      style={{
                        float: "right",
                        cursor: "pointer",
                        fontSize: "1.4em",
                      }}
                    />

                    <div style={{ marginTop: "10%" }}>
                      <h1 style={{ textAlign: "center" }}>
                        Edit Price Sheet Template Data
                      </h1>
                      <Row gutter={10}>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>
                                Company Name
                              </span>
                            }
                          >
                            {getFieldDecorator("companyName", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Company Name",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>Address</span>
                            }
                          >
                            {getFieldDecorator("address", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Address",
                                },
                              ],
                            })(
                              <LocationAutocomplete
                                getAddress={(address, latLng) =>
                                  this.getAddress(address, latLng, "address")
                                }
                                editMode={true}
                                address={this.state.selectedTemplateAddress}
                                setAddress={(address) => {
                                  this.setState({
                                    selectedTemplateAddress: address,
                                  });
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>
                                Phone Number
                              </span>
                            }
                          >
                            {getFieldDecorator("phone", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Phone Number",
                                },
                                noWhitespaceRule,
                                notValidPhoneNumberRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>Email</span>
                            }
                          >
                            {getFieldDecorator("email", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Email Address",
                                },
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>Website</span>
                            }
                          >
                            {getFieldDecorator("website", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Website",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>Notes</span>
                            }
                          >
                            {getFieldDecorator("notes", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Notes",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          {/* <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                            }}
                            showUploadList={false}
                            beforeUpload={this.beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "companyLogo")
                            }
                          >
                            <Button>
                              <Icon type="upload" />
                              Update Company Logo
                            </Button>
                          </Upload> */}
                          <Form.Item
                            label={
                              <span style={{ color: "#0E4D90" }}>
                                Company Logo
                              </span>
                            }
                          >
                            {getFieldDecorator("deliveryPic", {
                              // rules: [{ required: true, message: 'Please upload delivery image' }],
                            })(
                              <Spin spinning={this.state.pricesheetDataLoading}>
                                <Col span={24}>
                                  <Upload
                                    name="avatar"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    style={{
                                      borderRadius: "50%",
                                    }}
                                    showUploadList={false}
                                    beforeUpload={this.beforeUpload}
                                    onChange={(e) =>
                                      this.handleUploadPic(e, "companyLogo")
                                    }
                                  >
                                    {this.state?.companyLogo ? (
                                      <img
                                        src={
                                          this.state?.companyLogo &&
                                          this.state?.companyLogo.includes(
                                            ".pdf"
                                          )
                                            ? Docsample
                                            : `https://${
                                                process.env.REACT_APP_S3_BUCKET
                                              }.s3.amazonaws.com/public/${encodeURIComponent(
                                                this.state?.companyLogo
                                              )}`
                                        }
                                        alt="avatar"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <CameraOutlined
                                        className="camera-icon-carrier"
                                        style={{
                                          width: "150px",
                                          height: "150px",
                                          paddingTop: "70px",
                                        }}
                                      />
                                    )}
                                  </Upload>
                                </Col>
                              </Spin>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </Modal>
                </Form>
                {/* <TabPane
                  tab={
                    <h1>
                      <b>Price Sheet Template </b>
                    </h1>
                  }
                  key="4"
                >
                  <PriceQuoteTool />
                </TabPane> */}
                {/* <TabPane
                  tab={
                    <h1>
                      <b>Carrier Tags</b>
                    </h1>
                  }
                  key="5"
                >
                  <Row style={{ margin: "50px" }}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h1>Tags</h1>
                      <Spin spinning={this.state.tagsDataLoading}>
                        <Row>
                          <div>
                            {this.state.masterData["carrierTag"] &&
                              this.state.masterData["carrierTag"]
                                .sort((a, b) =>
                                  a["name"] > b["name"] ? 1 : -1
                                )
                                .map((tag) => {
                                  return (
                                    <div
                                      className={
                                        this.state.selectedTag === tag.id
                                          ? "category_active"
                                          : "category"
                                      }
                                      key={"div" + tag["id"]}
                                    >
                                      <li
                                        key={tag.id}
                                        onClick={() =>
                                          this.setState({ selectedTag: tag.id })
                                        }
                                      >
                                        <Row>
                                          <Col lg={20} md={20} sm={24} xs={24}>
                                            <p style={{ marginLeft: "10px" }}>
                                              {tag.name.toUpperCase()}
                                            </p>
                                          </Col>
                                          <Col lg={2} md={2} sm={24} xs={24}>
                                            <EditFilled
                                              title="Edit"
                                              onClick={() =>
                                                this.showCatAndSubCatModal(
                                                  tag.id,
                                                  tag.name,
                                                  "carrierTag",
                                                  "edit"
                                                )
                                              }
                                              style={{
                                                fontSize: "1.2em",
                                                color: "lightgray",
                                              }}
                                            />
                                          </Col>
                                          <Col lg={2} md={2} sm={24} xs={24}>
                                            <DeleteFilled
                                              title="Delete"
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    "Are you sure you want to delete this tag?"
                                                  )
                                                )
                                                  this.deleteCategory(
                                                    tag.id,
                                                    "carrierTag"
                                                  );
                                              }}
                                              style={{
                                                fontSize: "1.2em",
                                                color: "lightgray",
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </li>
                                    </div>
                                  );
                                })}
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <Button
                                onClick={() =>
                                  this.showCatAndSubCatModal(
                                    null,
                                    null,
                                    "carrierTag",
                                    "new"
                                  )
                                }
                                style={{
                                  marginTop: "2%",
                                  backgroundColor: "#0E4D90",
                                  borderColor: "#0E4D90",
                                  color: "#FFF",
                                }}
                              >
                                Add Tag
                              </Button>
                            </Col>
                          </div>
                        </Row>
                      </Spin>
                    </Col>
                    <Modal
                      // title={this.state.categoryTitle}
                      visible={this.state.visible}
                      footer={[
                        <Button
                          key="cancel"
                          className="cancel"
                          onClick={() => {
                            this.setState({ visible: false });
                          }}
                        >
                          Cancel
                        </Button>,
                        <Button
                          key="assign"
                          className="assigning"
                          loading={this.state.catAndSubCatAddingLoadingStatus}
                          onClick={this.handleOk}
                        >
                          {this.state.buttonTitle}
                        </Button>,
                      ]}
                    >
                      <CloseOutlined
                        onClick={() => {
                          this.setState({ visible: false });
                        }}
                        style={{
                          float: "right",
                          cursor: "pointer",
                          fontSize: "1.4em",
                        }}
                      />
                      <h2>{this.state.title}</h2>
                      <div style={{ marginTop: "7%" }}>
                        <Form.Item
                          label={
                            <span style={{ color: "#7B8190" }}>
                              {this.state.questionTitle}
                            </span>
                          }
                        >
                          {getFieldDecorator("fieldValue", {
                            rules: [
                              {
                                required: true,
                                whitespace: true,
                                message: "Please input text",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item>
                          {getFieldDecorator(
                            "recordId",
                            {}
                          )(<Input type="hidden" />)}
                        </Form.Item>
                        <Form.Item>
                          {getFieldDecorator("fieldType", {
                            rules: [
                              {
                                required: true,
                              },
                            ],
                          })(<Input type="hidden" />)}
                        </Form.Item>
                      </div>
                    </Modal>
                  </Row>
                </TabPane> */}
                <Modal
                  title="Show Map"
                  visible={this.state.imageModal}
                  onOk={this.imageHandleOk}
                  onCancel={this.imageHandleCancel}
                >
                  <div>
                    <img
                      src={this.state.mapPath}
                      alt="map"
                      style={{ width: "100%" }}
                    />
                  </div>
                </Modal>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "settings" })(
  withAppContext(withRouter(Settings))
);
// export default withAppContext(withRouter(Settings));
